
<div class="h-100 w-100">
    <c-site-contract-flip-card
        v-if      = "contractValid"
        :title    = "$t('contract.zus.title')"
        :contract = "contract"
        :edit     = "true"
        :unit     = "unit"
        @readonly = "onReadonly"
        @store    = "onStore"
    >
        <template v-slot:front>
            <div>
                <f-title
                    class  = "mt-3"
                    :title = "$t('contract.terms')"
                />

                <v-row class="no-frame mt-3">
                    <v-col class="no-frame pr-2">
                        <f-currency-field-rw
                            class     = "money"
                            :label    = "$t('contract.zus.costsMainAudit')"
                            :readonly = "readonly"
                            v-model   = "contract.unit.mainAudit"
                        />
                    </v-col>
                    <v-col class="no-frame p-2">
                        <f-currency-field-rw
                            class     = "money"
                            :label    = "$t('contract.zus.costIntermediateAudit')"
                            :readonly = "readonly"
                            v-model   = "contract.unit.intermediateAudit"
                        />
                    </v-col>
                </v-row>

                <v-row class="no-frame mt-2">
                    <v-col class="no-frame pr-2">
                        <f-currency-field-rw
                            class     = "money"
                            :label    = "$t('contract.zus.costAuditAfterChange')"
                            :readonly = "readonly"
                            v-model   = "contract.unit.auditAfterChange"
                        />
                    </v-col>
                    <v-col class="no-frame p-2">
                        <f-currency-field-rw
                            class     = "money"
                            :readonly = "readonly"
                            :label    = "$t('contract.zus.costAuditAfterDefects')"
                            v-model   = "contract.unit.auditAfterDefects"
                        />
                    </v-col>
                </v-row>
            </div>
        </template>
    </c-site-contract-flip-card>

    <div
        v-if  = "!contractValid"
        class ="w-100 h-100"
    >
        <c-column-header
            label = "ZÜS (kein Vertrag)"
            class  = "primary mb-1 w-100"
        />
        <div class  = "lm-border mb-1 w-100" style="height: calc(100% - 29px)">

        </div>
    </div>

</div>
